<template>
  <v-data-table
    v-if="classification && feature"
    class="elevation-5"
    :headers="headers"
    :items="rules"
    :loading="loadingRules"
    :no-data-text="noDataText"
    :pagination.sync="pagination"
    :rows-per-page-items="rowsPerPageItems"
    :total-items="rulesTotal"
  >
    <template #items="{ item }">
      <tr @click="setRuleAndSearch(item)">
        <td>{{item.value}}</td>
        <td class="text-xs-right">{{item.featuresCreated}}</td>
        <td>{{item.likePattern || '-'}}</td>
        <td>{{item.notLikePattern || '-'}}</td>
        <td>{{item.brands.join(', ')}}</td>
        <td class="text-xs-center">
          <v-rules-table-delete-btn :rule="item" />
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import VRulesTableDeleteBtn from "./RulesTableDeleteBtn";

export default {
  components: {
    VRulesTableDeleteBtn
  },
  data: () => ({
    isTheFirstPaginationMutation: true, // See pagination.set function
    headers: [
      {
        text: "Valor",
        align: "left",
        sortable: false
      },
      {
        text: "Atributos creados gracias a esta regla",
        align: "right",
        sortable: false
      },
      {
        text: "Patrón LIKE",
        align: "left",
        sortable: false
      },
      {
        text: "Patrón NOT LIKE",
        align: "left",
        sortable: false
      },
      {
        text: "Marcas",
        align: "left",
        sortable: false
      },
      {
        text: "Eliminar",
        align: "center",
        sortable: false
      }
    ],
    rowsPerPageItems: [5, 15, 30, 50, 100, 250, 500, 1000]
  }),
  computed: {
    ...mapState("featureRules", [
      "classification",
      "feature",
      "loadingRules",
      "rules",
      "rulesPagination",
      "rulesTotal"
    ]),
    noDataText() {
      return !this.loadingRules && this.classification && this.feature
        ? `No hay reglas creadas para la clasificación "${this.classification.name}" y atributo "${this.feature.name}"`
        : "";
    },
    pagination: {
      get() {
        return this.rulesPagination;
      },
      /**
       * As the pagination is a property with sync, inmediately after the creation it sets the pagination
       * object in the store, and this trigger the getRules action again, that was called after setting the
       * selected feature in the store. So, to avoid getting the rules twice we have this flag
       * `isTheFisrtPaginationMutation` to avoid getting the rules again.
       */
      set(pagination) {
        let getRules = true;
        if (this.isTheFirstPaginationMutation) {
          this.isTheFirstPaginationMutation = false;
          getRules = false;
        }
        this.setRulesPagination({ pagination, getRules });
        this.isTheFirstPaginationMutation = false;
      }
    }
  },
  methods: {
    ...mapActions("featureRules", ["getItems", "setRulesPagination"]),
    ...mapMutations("featureRules", [
      "setFeatureValue",
      "setLikePattern",
      "setSelectedBrands"
    ]),
    async setRuleAndSearch(rule) {
      this.setLikePattern({
        like: rule.likePattern,
        notLike: rule.notLikePattern
      });
      this.setSelectedBrands(rule.brands);
      await this.getItems();
      this.setFeatureValue(rule.value);
    }
  }
};
</script>

<style scoped>
td {
  cursor: pointer;
}
</style>